<template>
    <div>
        <!-- 大弹窗 -->
        <div class="menuandvideo" :style="{ zIndex: new Date().getTime() - 1741763154594 }"
            v-if="recommend_info.styleType == 1">
            <div class="pro_recommend" style="cursor: pointer;">
                <div class="gradient">
                    <span style="position: relative; z-index: 10; cursor: pointer;" @click="excitrecommend"><i
                            style="color: #999999;font-weight: bold;" class="el-icon-close"></i></span>
                </div>
                <div class="top" v-if="showthis">
                    <div id="rec_poster">
                        <img src="../../assets/lives/sz.png" style="width: 13px;vertical-align: middle;">
                        <countd :end-time="rec_endtime" @countdown_show="countdown_show"></countd>
                        <span>后失效</span>
                    </div>
                </div>
                <div :class="['priceimg', !showthis ? 'mt32' : '']">
                    <div class="goodsImage" :style="{
                        backgroundImage: `url(${recommend_info.productSpuDTO.spuImage[0].imageUrl})`,
                        height: '223px',
                        width: '223px'
                    }">
                        <div class="sq" v-if="recommend_info.productSellOutStatus === 'selloutIng'">已售罄</div>
                    </div>
                </div>
                <div class="sputitle">
                    <div class="spuName">{{ recommend_info.productSpuDTO.spuName }}{{ recommend_info.sendTim
                        }}</div>
                </div>
                <div class="price">
                    <span style="font-weight:bold;"><span style="font-size: 12px;">￥</span>{{
                        recommend_info.productSpuDTO.skuList[0].salePrice / 100 }}</span>
                    <span class="price-strike" v-if="recommend_info.productSpuDTO.oriPrice != 0">￥{{
                        recommend_info.productSpuDTO.oriPrice / 100 }}</span>
                </div>
                <div class="btn" style="cursor: pointer;">
                    <div class="tjsq qg" v-if="recommend_info.productSellOutStatus === 'selloutIng'"
                        @click="click_buy(recommend_info.id)">{{ productSoldOutDesc }}</div>
                    <div class="qg" v-if="recommend_info.productSellOutStatus === 'unsellout'"
                        @click="click_buy(recommend_info.id)">{{ buyButtonText }}</div>
                </div>



                <div class="giftfk" v-if="paycode" style="z-index: 121;">
                    <div>请用微信扫码支付</div>
                    <fkcode :link="recommend_url"></fkcode>
                    <div style="color:#256EE7;margin-top: 20px;" @click="cancelpay()">取消支付</div>
                </div>
            </div>
            <div class="mb_giftfk" v-if="paycode" style="z-index: 120;">
            </div>
        </div>
        <!-- 小弹窗 -->
        <div class="smallrecommend" v-if="recommend_info.styleType == 2">
            <div class="hot hottext" v-if="recommend_info.showHeatFlag == 'T'">
                <img src="../../image/exam/hot.png" alt="" srcset="">
                <div>热 卖 <span style="font-size: 13px; margin-left: 5px;">X</span></div>
                <Transition name="bounce">
                    <span style="font-size: 20px; ">{{ recommend_info.heat }}</span>
                </Transition>
            </div>
            <div class="pro_recommend">
                <div :class="['priceimg', 'smallpriceimg', !showthis ? '' : '']">
                    <div class="action">
                        <div style="width: 16px;"></div>
                        <div id="rec_poster" v-if="showthis">
                            <img src="../../assets/lives/sz.png" style="width: 13px;vertical-align: middle;">
                            <countd :end-time="rec_endtime" @countdown_show="countdown_show"></countd>
                            <span>后失效</span>
                        </div>
                        <div class="close">
                            <span style="position: relative; z-index: 10; cursor: pointer;" @click="excitrecommend"><i
                                    style="color: #fff;font-weight: bold;" class="el-icon-close close-icon"></i></span>
                        </div>
                    </div>
                    <div class="goodsImage" :style="{
                        backgroundImage: `url(${recommend_info.productSpuDTO.spuImage[0].imageUrl})`,
                    }">
                        <div class="sq" v-if="recommend_info.productSellOutStatus === 'selloutIng'">已售罄</div>
                    </div>
                </div>
                <div class="sputitle">
                    <div class="spuName">{{ recommend_info.productSpuDTO.spuName }}{{ recommend_info.sendTim
                        }}</div>
                </div>
                <div class="price">
                    <span style="font-weight:bold;"><span style="font-size: 12px;">￥</span>{{
                        recommend_info.productSpuDTO.skuList[0].salePrice / 100 }}</span>
                    <span class="price-strike" v-if="recommend_info.productSpuDTO.oriPrice != 0">￥{{
                        recommend_info.productSpuDTO.oriPrice / 100 }}</span>
                </div>
                <div class="btn">
                    <div class="tjsq qg" v-if="recommend_info.productSellOutStatus === 'selloutIng'"
                        @click="click_buy(recommend_info.id)">{{ productSoldOutDesc }}</div>
                    <div class="qg" v-if="recommend_info.productSellOutStatus === 'unsellout'"
                        @click="click_buy(recommend_info.id)">{{ buyButtonText }}</div>
                </div>
                <div v-if="paycode" class="qrcodepop" style="z-index: 121;">
                    <!-- border: 1px solid #FBB300; -->
                    <div
                        style="background: #fff; border-radius: 10px;width: 180px;display: flex;flex-direction:column; align-items: center;padding: 50px; height: 240px;justify-content: center;">
                        <div>请用微信扫码支付</div>
                        <fkcode :link="recommend_url"></fkcode>
                        <div style="color:#256EE7; margin-top: 10px;" @click="cancelpay()">取消支付</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import fkcode from './fkcode.vue';
import countd from './countdown_rec.vue';

export default {
    name: 'recommend',
    components: {
        fkcode,
        countd
    },
    props: {
        recommend_info: Object,
        buyButtonText: {
            type: String,
            default: '立即抢购'
        },
        productSoldOutDesc: {
            type: String,
            default: '已售罄'
        }
    },
    data() {
        return {
            paycode: false,
            recommend_url: '',
            count: 60,
            rec_endtime: 0,
            times: null,
            time: null,
            showthis: false,
        }
    },
    watch: {
        recommend_info() {
            this.rec_endtime = this.recommend_info.endTime
            if (this.recommend_info.endTime >= new Date().getTime()) {
                this.rec_endtime = this.recommend_info.endTime
                this.showthis = true
            }
        },
    },
    mounted() {
        if (this.recommend_info.endTime >= new Date().getTime()) {
            this.rec_endtime = this.recommend_info.endTime
            this.showthis = true
        }
    },
    methods: {
        excitrecommend() {
            this.$emit("excitrecommend", false)
        },
        countdown_show(val) {
            //倒计时结束

            if (val == false) {

                this.$emit("excitrecommend", false)
            }



        },
        click_buy() {
            if (this.recommend_info.productSellOutStatus === 'selloutIng') {
                this.$message({ type: 'error', message: '商品已售罄' })
                return
            } {
                this.recommend_url = window.location.href
                this.paycode = true
            }
        },

        cancelpay() {
            this.paycode = false
        },
        //检查订单状态
        wxcheckorder(val, url) {
            this.$api.wxcheckorder(val).then(res => {
                console.log(res);
                if (res.data.data.stats == 1) {
                    clearInterval(this.times);
                    clearInterval(this.time)
                    this.paycode = false
                    this.count = 60;
                    this.$emit("recommendSucess", "支付成功");
                    this.$message({
                        message: "支付成功",
                        type: "success"
                    });
                }
            })
        },
    },

}
</script>
<style scoped>
.menuandvideo {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .7);
    display: flex;
    justify-content: center;
}

.menuandvideo .pro_recommend {
    width: 265px;
    border: 1px solid #FBB300;
    position: absolute !important;
    top: 25vh;

}

.menuandvideo .gradient {
    position: absolute;
    top: 0;
    left: 0;
    width: 265px;
    height: 49px;
}

.pro_recommend {
    overflow: hidden;
    background-color: #fff;
    position: relative;
    border-radius: 10px;
}

.pro_recommend .close-icon {}

.gradient {
    text-align: right;
    background-image: linear-gradient(to bottom, #F6DBC4, white);
    padding-right: 5px;
    box-sizing: border-box;
}


.priceimg {
    display: flex;
    justify-content: center;
}

.smallpriceimg {
    position: relative;
}

.smallpriceimg .action {
    z-index: 100;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 8px;
    box-sizing: border-box;
    align-items: center;
}

.mt32 {
    margin-top: 32px;
}

.goodsImage {
    width: 187px;
    height: 187px;
    border-radius: 4px;
    background-position: center;
    background-size: cover;
    position: relative;
}

.sq {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
    line-height: 187px;
    color: #fff;
}

.sputitle {
    display: flex;
    justify-content: center;
    padding: 0 23px;
    margin-top: 13px;
}

.spuName {
    color: #572E18;
    font-size: 13px;
    text-align: left;
    font-size: 13px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    /* 设置文本换行 */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;


    /* width: 228px; */
}

.btn {
    /* display: flex;
    height: 34px;
    margin-top: 18px; */
    padding: 8px 14px;

}



.qg {
    background: #F7DA9E;
    height: 40px;
    color: #572E18;
    border-radius: 28px;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
}

.tjsq {
    background: #999;
    color: #fff;
}

/* .btn div {
    cursor: pointer;
    width: 50%;
    border-radius: 4px;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    line-height: 34px;
} */

.price {
    color: #E8341F;
    border-bottom-right-radius: 37px;
    text-align: left;
    margin-top: 14px;
    padding: 0 23px;
}

.price-strike {
    text-decoration: line-through;
    text-decoration-color: #ccc;
    color: #bbb;
    padding-left: 18px;
    font-size: 12px;
}

.giftfk {
    position: absolute;
    width: 100%;
    /* margin: auto; */
    height: 100%;
    top: 0;
    left: 0;
    background: #fff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
}



.top {
    padding-top: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    position: relative;
    z-index: 1;
}

#rec_poster {
    background: #FCEEE9;
    border-radius: 10px;
    color: #DA7651;
    font-size: 12px;
    padding: 4px 9px;
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: bold;
}




.smallrecommend {
    position: absolute;
    bottom: 10px;
    right: 10px;
    overflow: hidden;
}

.smallrecommend .pro_recommend {
    position: static;
}

.smallrecommend .hot {
    width: 180px;
    height: 30px;
    padding-left: 10px;
    background: linear-gradient(to left, #dfd1b3, #FBB300);
    border-image: linear-gradient(to right, #000, rgba(0, 0, 0, 0)) 1;
    border-right: 0;
    margin-bottom: 10px;
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    display: flex;
    align-items: center;
    color: #fff;
}

.smallrecommend .hottext {
    font-size: 16px;
    font-weight: 500;
    padding-left: 6px;
    font-style: italic;
}

.bounce-enter-active {
    animation: bounce-in 0.5s;
}

.bounce-leave-active {
    animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }

    50% {
        transform: scale(1.25);
    }

    100% {
        transform: scale(1);
    }
}

.qrcodepop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
</style>
